// tool-fair-pay-festival.jsx: losse tool /tools/fair-pay-festival
// Filmfestival: vorm (zzp/loondienst) → functieomschrijving → schaal/tarief.
// Voorgevulde state: type=festival, perspectief=uitvoerder. Vorm wordt door
// gebruiker gekozen in stap 0. Geen AI; eindstation is StepNiveau (toont
// schaal & tarief, geen 'verder' knop; voor festival-families met varianten
// wordt eerst de variant-substep doorlopen).
import React from "react";
import { ToolShell } from "./tool-shell";
import { useToolState, useToolStep } from "./tool-storage";
import { FestivalVormKeuze } from "../ui/steps/step0-scope";
import { StepRol } from "../ui/steps/step1-rol";
import { StepNiveau } from "../ui/steps/step2-niveau";
import { StepHeader, FW } from "../ui/primitives";

const TOOL_KEY = "fair-pay-festival";
const INITIAL_STATE = {
  type: "festival",
  perspectief: "uitvoerder",
  omschrijving: "",
  rollen: [],
  // vorm: undefined, wordt in stap 0 gezet
};

const STEPS = ["Vorm", "Functieomschrijving", "Schaal & tarief"];

export const ToolFairPayFestival = () => {
  const [state, setState] = useToolState(TOOL_KEY, INITIAL_STATE);
  const [step, setStep] = useToolStep(TOOL_KEY, STEPS.length - 1);

  const next = () => setStep(s => Math.min(STEPS.length - 1, s + 1));
  const back = () => setStep(s => Math.max(0, s - 1));

  const pickVorm = (v) => {
    setState(s => {
      const vormGewijzigd = s.vorm && s.vorm !== v;
      // Bij wisseling tussen zzp ↔ loondienst de rol-specifieke downstream-state
      // wissen (analoog aan StepScope.pickVorm in de volledige flow).
      const rollen = vormGewijzigd
        ? (s.rollen || []).map(r => ({
            ...r,
            werkdagen: undefined,
            dienstverband: undefined,
            periodiek: undefined,
          }))
        : s.rollen;
      return { ...s, type: "festival", perspectief: "uitvoerder", vorm: v, rollen };
    });
    setTimeout(next, 150);
  };

  return (
    <ToolShell steps={STEPS} currentStep={step} onJumpTo={setStep}>
      {step === 0 && (
        <div>
          <div style={{ marginBottom: 12, display: "inline-flex", padding: "4px 10px", borderRadius: 6,
            background: FW.cyan, color: FW.navy, fontSize: 12, fontWeight: 700,
            textTransform: "uppercase", letterSpacing: 0.5 }}>
            Filmfestival
          </div>
          <h1 className="step-hero" style={{ fontSize: 44, lineHeight: 1.1, margin: "8px 0 28px", letterSpacing: "-0.01em", fontWeight: 700 }}>
            Werk je als zzp'er of in loondienst?
          </h1>
          <FestivalVormKeuze onPick={pickVorm} stapLabel="" />
        </div>
      )}
      {step === 1 && (
        <StepRol
          state={state}
          setState={setState}
          next={next}
          back={back}
          disableAI
        />
      )}
      {step === 2 && (
        <StepNiveau
          state={state}
          setState={setState}
          back={back}
          hideNext
        />
      )}
    </ToolShell>
  );
};
